import { CommonStyles } from '../../../common/react/CommonStyles';

export const authenticationProviderOptionStyle: React.CSSProperties = {
    marginBottom: CommonStyles.Sizes.NormalFontSize
};

export const authenticationProviderOptionDescriptionStyle: React.CSSProperties = {
    fontSize: CommonStyles.Sizes.SmallFontSize
};

export const configureAuthenticationLinkStyle: React.CSSProperties = {
    fontSize: CommonStyles.Sizes.SmallFontSize
};

export const authenticationRadioButtonsStyle: React.CSSProperties = {
    marginLeft: CommonStyles.Sizes.DefaultSpace,
    marginBottom: CommonStyles.Sizes.NormalFontSize
};